import React from 'react'
import { Tabs } from 'antd'

import PersonalWhatsapp from 'components/UI/SendWaModal/PersonalWhatsapp'
import OfficialWhatsapp from 'components/UI/SendWaModal/OfficialWhatsapp'

const FormTab = ({
  getWaTemplate,
  hideOfficial,
  id,
  show,
  transTypeId,
  waTemplateKey,
  onChangeWhatsappType,
  whatsappType,
}) => {
  if (!transTypeId || hideOfficial) {
    return (
      <PersonalWhatsapp waTemplateKey={waTemplateKey} getWaTemplate={getWaTemplate} show={show} />
    )
  }

  return (
    <Tabs
      defaultActiveKey={whatsappType}
      onChange={onChangeWhatsappType}
      size="small"
      style={{ marginBottom: 32 }}
      destroyOnHidden
      items={[
        {
          key: 1,
          label: 'Personal Whatsapp',
          children: (
            <PersonalWhatsapp
              waTemplateKey={waTemplateKey}
              getWaTemplate={getWaTemplate}
              show={show}
            />
          ),
        },
        {
          key: 2,
          label: 'Official Whatsapp',
          children: <OfficialWhatsapp id={id} transTypeId={transTypeId} />,
        },
      ]}
    />
  )
}

export default FormTab
